.outerContainer {
  padding: 0;
  flex: 1;
  overflow: hidden;
}

.innerRow {
  overflow: hidden;
  flex: 1;
}

.contentColumn {
  flex: 1;
  overflow: hidden;
  transform: translateZ(0);
}

.contentBox {
  flex: 1;
  overflow: hidden;
}
